import { Heading, IconButton, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { InfoPanel } from '../InfoPanel';

export namespace HeaderTypes {
  export interface Props {
    isMobile: boolean;
    onGoBack?: () => void;
  }
}

export const Header: React.FC<HeaderTypes.Props> = ({ isMobile, onGoBack }) => {
  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['stack.nano']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={isMobile ? undefined : 3}
          variant={isMobile ? 'unstyled' : 'link'}
          iconColor={isMobile ? Color['neutral.dark'] : Color['brand.tertiary.principal']}
          iconSize="xs"
          padding={{ base: 0, sm: Spacing['inset.nano'] }}
          onPress={onGoBack}
        />
        {isMobile ? (
          <Text fontSize={Typography['fontsize.lg']} variant="bold">
            Detalhes do cliente
          </Text>
        ) : (
          <Heading testId="customer-details-heading">Detalhes do cliente</Heading>
        )}
      </HStack>
      {isMobile && <InfoPanel />}
    </HStack>
  );
};
